import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { translations, getTranslation } from '../config/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('he'); // Default to Hebrew

  // Derive direction from language
  const direction = useMemo(() => language === 'he' ? 'rtl' : 'ltr', [language]);

  useEffect(() => {
    // Update document direction and language
    document.documentElement.dir = direction;
    document.documentElement.lang = language;
  }, [language, direction]);

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'he' ? 'en' : 'he'));
  };

  const t = (key) => getTranslation(language, key);

  const value = {
    language,
    direction,
    setLanguage,
    toggleLanguage,
    t,
    translations: translations[language],
    isRTL: language === 'he',
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
